// 三维
import * as THREE from "three";
// 绘制文字
import { rlTextData, rlCircleData } from "@/rlMxModules/rlDataClass/index";

// 判断节点是否在网格上
import { ptOnLine } from "@/rlMxModules/operate/commonApi";
// 提示信息
import { Message } from "element-ui";
import store from "@/store";
// 构件号命名
import { PartNumberNaming } from "@/utils/rlModuleUtils";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { McDbAlignedDimension, McDb, McGePoint3d, McCmColor } from "mxcad";
import { getJointAxis } from "@/rlMxModules/operate/axisNaming";
import { getrlStdFlr } from "@/mixins/LiteModuleDb.js";
/**
 * 沉降检测/倾斜检测方法封装
 */
// 日期转换
export function getDateYear() {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const dates = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${dates}`;
}

// 获取沉降检测的位置信息
export const getSubsidencePlace = async (siteList) => {
  const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
  await getPoint.go();
  const pt1 = getPoint.value();
  if (!pt1 || !store.state.detectionModule.btnDrawStatus) return;

  // 计算最近的节点
  const rlJointArray = store.state.rlEntData.totalEntityData["rlJoint"];
  let minDist = 10000;
  let closestJointData = null;
  for (let i = 0; i < rlJointArray.length; i++) {
    const item = rlJointArray[i];
    const pt2 = new THREE.Vector3(...item.m_pt);
    const dist = pt1.distanceTo(pt2);
    if (dist < minDist) {
      minDist = dist;
      closestJointData = item;
    }
    if (dist < 300) break;
  }
  const floorData = await getrlStdFlr(
    store.state.cadModules.rlBuilding.StdFlrGuid
  );
  if (!floorData) return false;
  const gridDatas = floorData["rlGrid"];
  const axisDatas = floorData["rlAxis"];
  const jointDatas = floorData["rlJoint"];

  const matchAxisDatas = getJointAxis(
    closestJointData.getDataBase(),
    jointDatas,
    axisDatas,
    gridDatas
  );
  if (matchAxisDatas && matchAxisDatas.length > 0) {
    // 获取matchAxisDatas中的name字段
    const axisNames = matchAxisDatas.map((item) => item.Name);
    const axisName = axisNames.join("-");
    const addObject = await drawSvg(siteList, pt1);
    addObject.ModelNo = axisName;
    addObject.ModelGuid = 1;
    addObject.floorGuid = store.state.cadModules.rlBuilding.Guid;
    addObject.ModelName = axisName;
    return addObject;
  }

  // 获取节点上的轴线，计算节点位置的轴号
  // if (closestJointData) {
  //   let axisIds = closestJointData.m_AxisIds;
  //   if (axisIds && axisIds.length == 2) {
  //     let axis1 = getEntityData({
  //       Guid: axisIds[0],
  //       classTypeName: "rlAxis",
  //     });
  //     let axis2 = getEntityData({
  //       Guid: axisIds[1],
  //       classTypeName: "rlAxis",
  //     });
  //     if (axis1 && axis2) {
  //       let axisNo1 = axis1.Name;
  //       let axisNo2 = axis2.Name;
  //       let axisNo = axisNo1 + "-" + axisNo2;
  //       let axisName = axis1.m_AxisName + "-" + axis2.m_AxisName;
  //       // let axisGuid = axis1.Guid + "-" + axis2.Guid;
  //       let addObject = await drawSvg(siteList, pt1);
  //       addObject.ModelNo = axisNo;
  //       // addObject.ModelType = "rlAxis";
  //       addObject.ModelGuid = 1;
  //       addObject.floorGuid = store.state.cadModules.rlBuilding.Guid;
  //       addObject.ModelName = axisName;
  //       return addObject;
  //     }
  //   }
  // }

  Message.warning("未找到轴线");
  return false;
};

// 获取倾斜检测的位置信息
export const getSlopePlace = async (siteList) => {};

// *** 动态取点 ***
export const getSvgPoints = async (siteList) => {
  const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
  await getPoint.go();
  const pt1 = getPoint.value();
  if (!pt1 || !store.state.detectionModule.btnDrawStatus) return;

  const rlGridGroup = await store.state.rlEntData.totalEntityData["rlGrid"];
  if (!rlGridGroup) return false;

  // 查找最近的网格
  let lastMinDist = 10000;
  let closestGrid = null;

  // 遍历每一个轴网
  for (let i = 0; i < rlGridGroup.length; i++) {
    const item = rlGridGroup[i];
    const line = new THREE.Line3(
      new THREE.Vector3(...item.m_stJoint.m_pt),
      new THREE.Vector3(...item.m_edJoint.m_pt)
    );

    // 获取光标到该轴网的最近点
    const closestPoint = new THREE.Vector3();
    line.closestPointToPoint(pt1, true, closestPoint);
    const dist = closestPoint.distanceTo(pt1);

    // 记录最小距离的轴网
    if (dist < lastMinDist) {
      lastMinDist = dist;
      closestGrid = item;
    }
  }

  if (closestGrid) {
    const pt1Tmp = new THREE.Vector3(...closestGrid.m_stJoint.m_pt);
    const pt2Tmp = new THREE.Vector3(...closestGrid.m_edJoint.m_pt);

    let ModelId = null;
    let classType = null;
    if (pt1Tmp.distanceTo(pt1) < 50 && closestGrid.m_stJoint.m_cloumId) {
      ModelId = closestGrid.m_stJoint.m_cloumId;
      classType = "rlColSeg";
    } else if (pt2Tmp.distanceTo(pt1) < 50 && closestGrid.m_edJoint.m_cloumId) {
      ModelId = closestGrid.m_edJoint.m_cloumId;
      classType = "rlColSeg";
    } else {
      if (closestGrid.m_wallId) {
        ModelId = closestGrid.m_wallId;
        classType = "rlWallSeg";
      } else if (closestGrid.m_beamId) {
        ModelId = closestGrid.m_beamId;
        classType = "rlBeamSeg";
      }
    }

    const construct = getEntityData({
      Guid: ModelId,
      classTypeName: classType,
    });
    if (construct) {
      const addObject = await drawSvg(siteList, pt1);
      addObject.ModelNo = PartNumberNaming(
        store.state.cadModules.rlBuilding,
        construct
      );
      addObject.ModelType = construct.classType;
      addObject.ModelGuid = construct.Guid;
      addObject.floorGuid = store.state.cadModules.rlBuilding.Guid;
      return addObject;
    }
  }

  Message.warning("未找到关联构件");
  return false;
};

// 设置返回构件数据
async function processObject(siteList, item, res, pt1) {
  const addObject = await drawSvg(siteList, pt1);
  const ModelId =
    res === 1
      ? item.m_wallId ?? item.m_beamId
      : item[`${res === 2 ? "m_stJoint" : "m_edJoint"}`].m_cloumId;
  const classType =
    res === 1 && item.m_wallId
      ? "rlWallSeg"
      : res === 1 && item.m_beamId
      ? "rlBeamSeg"
      : "rlColSeg";
  const construct = getEntityData({
    Guid: ModelId,
    classTypeName: classType,
  });
  addObject.ModelNo = PartNumberNaming(
    store.state.cadModules.rlBuilding,
    construct
  );
  addObject.ModelType = construct.classType;
  addObject.ModelGuid = construct.Guid;
  addObject.floorGuid = store.state.cadModules.rlBuilding.Guid;

  return addObject;
}
// *** 绘制Svg图 ***
export const drawSvg = async (siteList, pt1, No_) => {
  const svg = new rlAppObj._rlMx.MxDbSVG();
  svg.setSvgPostion(new THREE.Vector3(pt1.x - 112.5, pt1.y - 145, 0));
  svg.setSvgPath("/img/eye.svg?timestamp=" + Date.now());
  svg.setColor(new THREE.Color(0xe7e320));
  svg.setSvgSize(new THREE.Vector2(200, 300));
  svg.setSvgAlignmentRatio(new THREE.Vector2(0, 0));
  rlAppObj.rlMxDrawObject.addMxEntity(svg);

  const maxNo =
    siteList && siteList.length > 0
      ? Math.max(...siteList.map((item) => (item.No_ ? item.No_ : 0)))
      : 0;
  const obj = {
    No_: No_ || maxNo + 1,
    pt1,
    svgId: svg.MxDbEntityImp.id,
  };

  // 等待drawTexts完成后再执行后续操作
  const addObject = await drawTexts(obj, {
    x: pt1.x - 240,
    y: pt1.y + 180,
    z: 0,
  });

  rlAppObj.rlMxDrawObject.updateDisplay();
  return addObject;
};
// *** 绘制圆圈文字 ***
export const drawTexts = async (obj, stExternPos) => {
  const m_stCircle = new rlCircleData();
  m_stCircle.ptCenter = new THREE.Vector3(
    stExternPos.x,
    stExternPos.y,
    stExternPos.z
  );
  m_stCircle.Radius = 200;
  m_stCircle.draw(true);

  const m_stText = new rlTextData();
  m_stText.position = stExternPos;
  m_stText.Text = obj.No_.toString();
  m_stText.draw(true);

  obj.textId = m_stText.mcDbId;
  obj.circleId = m_stCircle.mcDbId;

  return obj;
};
// *** 删除测点 - 传数组 ***
export const delMeasurePoint = async (entity, key) => {
  await entity.map((LI) => {
    if (!LI.textId) return;
    key.map((k) => {
      var obj = rlAppObj.rlMxDrawObject.getMxEntity(LI[k]);
      if (obj) {
        obj.erase();
      } else if (LI[k]) {
        LI[k].getMcDbEntity()?.erase();
      }
    });
  });
  rlAppObj.rlMxDrawObject.updateDisplay();
};
// *** 绘制标注 ***
export const drawMark = async (obj, isLe) => {
  const { ed, st, text } = obj;

  const mDimension = new McDbAlignedDimension();
  // 设置第一条线的端点
  mDimension.xLine1Point = new McGePoint3d(st.x, st.y);
  // 设置第二条线的端点
  mDimension.xLine2Point = new McGePoint3d(ed.x, ed.y);
  // 设置标注线的端点
  // mDimension.dimLinePoint = new McGePoint3d(
  //   isLe ? st.x : st.x - 1000,
  //   isLe ? st.y - 1000 : st.y
  // );
  // 设置文本附着点
  mDimension.textAttachment = McDb.AttachmentPoint.kTopLeft;
  // 设置文本旋转角度
  // mDimension.textRotation = 0.6;
  // 设置标注线及文字颜色
  mDimension.trueColor = new McCmColor(200, 255, 0);
  // 设置倾斜角度
  mDimension.oblique = 0;
  // 设置文本旋转角度
  mDimension.rotation = 0;
  // 设置文本内容
  mDimension.dimensionText = text;
  // 绘制实体
  var mDimensionId = rlAppObj.mxcadObject.drawEntity(mDimension);
  // 更新视图
  rlAppObj.rlMxDrawObject.updateDisplay();
  // 返回数据
  return mDimensionId;
};
// *** 手动绘制圆圈 ***
export const drawCircle = async (drawType) => {
  // 创建一个新的 rlAppObj._rlMx.MrxDbgUiPrPoint 对象，用于获取点
  const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
  let entity;

  if (drawType == 1) {
    // 如果 drawType 为 1，创建一个新的 rlAppObj._rlMx.MxDbEllipse 对象（椭圆）
    entity = new rlAppObj._rlMx.MxDbEllipse();
    // 等待用户选择第一个点，并将其赋值给 entity.point1
    entity.point1 = await getPoint.go();
    // 如果用户没有选择点，则返回
    if (!entity.point1) return;
  } else if (drawType == 2) {
    // 如果 drawType 为 2，创建一个新的 rlAppObj._rlMx.MxDbRect 对象（矩形）
    entity = new rlAppObj._rlMx.MxDbRect();
    // 等待用户选择第一个点，并将其赋值给 entity.pt1
    entity.pt1 = await getPoint.go();
    // 如果用户没有选择点，则返回
    if (!entity.pt1) return;
  }

  // 设置实体的颜色为红色（0xff0000）
  entity.setColor(0xff0000);

  // 设置用户绘制函数
  getPoint.setUserDraw((currentPoint, worldDraw) => {
    if (drawType == 1) {
      entity.point2 = currentPoint;
    } else if (drawType == 2) {
      entity.pt2 = currentPoint;
    }
    // 在世界坐标系中绘制自定义实体
    worldDraw.drawCustomEntity(entity);
  });

  // 等待用户选择第二个点
  const pt2 = await getPoint.go();
  // 如果用户没有选择点，则返回
  if (!pt2) return;

  if (drawType == 1) {
    entity.point2 = pt2;
  } else if (drawType == 2) {
    entity.pt2 = pt2;
  }

  // 将实体添加到 rlAppObj.rlMxDrawObject 中
  rlAppObj.rlMxDrawObject.addMxEntity(entity);
  return entity.MxDbEntityImp.id;

  return entity;
};

//  *** 直接生成圆 ***
export const generatingCircle = (data) => {
  // const circle = new rlAppObj._rlMx.MxDbCircle();
  if (!data || data.length == 0) return;
  data.forEach((res) => {
    let entity;
    const startPoint = res.points.startPoint;
    const endPoint = res.points.endPoint;
    if (res.type == "ellipse") {
      entity = new rlAppObj._rlMx.MxDbEllipse();
      entity.point1 = new THREE.Vector3(
        startPoint.x,
        startPoint.y,
        startPoint.z
      );
      entity.point2 = new THREE.Vector3(endPoint.x, endPoint.y, endPoint.z);
    } else if (res.type == "rect") {
      entity = new rlAppObj._rlMx.MxDbRect();
      entity.pt1 = new THREE.Vector3(startPoint.x, startPoint.y, startPoint.z);
      entity.pt2 = new THREE.Vector3(endPoint.x, endPoint.y, endPoint.z);
    }
    entity.classTypeName = res.type;
    entity.markerData = res.data;
    entity.setColor(0xff0000);
    rlAppObj.rlMxDrawObject.addMxEntity(entity);
    rlAppObj.rlMxDrawObject.updateDisplay();
  });
};

// *** 删除椭圆 ***
export const clearDraw = () => {
  let allMxEntity = rlAppObj.rlMxDrawObject.getAllMxEntity();
  // 过滤椭圆
  allMxEntity = allMxEntity.filter(
    (item) => item.classTypeName == "ellipse" || item.classTypeName == "rect"
  );
  allMxEntity.forEach((item) => {
    rlAppObj.rlMxDrawObject.eraseMxEntity(item.objectId());
  });
  // 关闭弹框
  store.commit("detectionModule/setMarkShow", false);
  store.commit("detectionModule/setMarkInfoShow", false);
  rlAppObj.rlMxDrawObject.updateDisplay();
};

//
export const drawOnlyText = async (stExternPos, text, fzMultiple) => {
  // stExternPos坐标, text文字, fzMultiple文字大小倍数
  const m_stText = new rlTextData();
  m_stText.position = stExternPos;
  m_stText.Text = text;
  var fz = await m_stText.calculateFontSize(text);
  m_stText.fontSize = fzMultiple ? fz * fzMultiple : fz;
  m_stText.draw(true);
  return m_stText.mcDbId;
};

// *** 承载力评级绘制 ***
export const drawLoadRating = async (resData) => {
  try {
    const ratingType = ["", "Aᵤ", "Bᵤ", "Cᵤ", "Dᵤ"];
    const promises = [];
    for (const item of resData) {
      const promise = (async () => {
        // 通过Guid获取构件数据
        const res = await getEntityData({
          Guid: item.guid,
          classTypeName: item.type,
        });
        const { minX, minY, maxX, maxY, centralX, centralY } =
          await getPointsMinMax(res);
        const isYGreaterThanX = +(minY + maxY) > +(minX + maxX); // 判断Y轴是否大于X轴 为纵向
        const text = `${
          item.type == "rlColSeg"
            ? "柱"
            : item.type == "rlBeamSeg"
            ? "梁"
            : "墙"
        }${ratingType[item.rating]}`;
        // 绘制文字 rlWallSeg
        const drawId = await drawOnlyText(
          {
            x:
              item.type == "rlColSeg"
                ? minX
                : item.type == "rlBeamSeg"
                ? isYGreaterThanX
                  ? centralX
                  : (centralX + maxX) / 2
                : isYGreaterThanX
                ? (centralX + minX) / 2
                : centralX,

            y:
              item.type == "rlColSeg"
                ? minY
                : item.type == "rlBeamSeg"
                ? isYGreaterThanX
                  ? (centralY + maxY) / 2
                  : centralY
                : isYGreaterThanX
                ? centralY
                : (centralY + minY) / 2,
            z: 0,
          },
          text,
          0.8
        );
        return {
          ...item,
          drawTextId: drawId, // 绘制文字id
        };
      })();
      promises.push(promise);
    }
    const retData = await Promise.all(promises);
    // 更新视图
    rlAppObj.rlMxDrawObject.updateDisplay();
    return retData;
  } catch (error) {}
};

// 计算顶点数据的最小和最大
export const getPointsMinMax = (pos) => {
  try {
    var maxX = 0;
    var maxY = 0;
    var minX = Infinity;
    var minY = Infinity;
    if (pos.points === undefined) return;
    for (var i = 0; i < pos.points.length; i += 3) {
      var x = pos.points[i];
      var y = pos.points[i + 1];
      if (x > maxX) {
        maxX = x;
      } else if (x < minX) {
        minX = x;
      }
      if (y > maxY) {
        maxY = y;
      } else if (y < minY) {
        minY = y;
      }
    }

    var centralX = (minX + maxX) / 2;
    var centralY = (minY + maxY) / 2;

    return { minX, minY, maxX, maxY, centralX, centralY };
  } catch (error) {
    return error;
  }
};
